module.exports = __webpack_public_path__ + "img/fatherhood_6.b5bd124e.jpg";